export default "__VITE_ASSET__CMRUXQbQ__"